<template>
  <div id="jumbotron">
    <div class="container">
      <top-nav :page_title="page_title"></top-nav>

      <form-wizard ref="formContainer" subtitle="Kindly input the correct information"
                   title="Sample Data Form" @submit.prevent="formSubmit">
        <!-- FLASH MESSAGES -->
        <FlashMessage :position="'right bottom'"></FlashMessage>

        <!-- ALTER TO LOAD SAVED FORM -->
        <div v-if="showAlert" class="alert alert-warning alert-dismissible fade show" role="alert">
          <p>
            You have an incomplete form which you saved. Do you want to restore it?
          </p>
          <div class="d-flex justify-content-end">
            <wizard-button class="btn btn-outline-danger btn-rounded" type="button"
                           @click.native="showOverwriteWarning=true; showAlert=false">
              No
            </wizard-button>
            <wizard-button class="btn btn-outline-primary btn-rounded" type="button" @click.native="restoreSavedForm">
              Yes
            </wizard-button>
          </div>
        </div>

        <div v-if="showOverwriteWarning" class="alert alert-danger alert-dismissible fade show" role="alert">
          <p>
            Proceeding without restoring previous form will have it overwritten. Do you wish to continue?
          </p>
          <div class="d-flex justify-content-end">
            <wizard-button class="btn btn-outline-primary btn-rounded" type="button" @click.native="restoreSavedForm">
              No
            </wizard-button>
            <wizard-button class="btn btn-outline-danger btn-rounded" type="button"
                           @click.native="deleteSavedForm">
              Yes
            </wizard-button>
          </div>
        </div>

        <!-- TAB 1 -->
        <tab-content :before-change="handleSubmit" title="Sample Details">
          <!--THEME-->
          <div class="form-group">
            <b-form-group id="form-theme" label="Select a Theme:" label-for="form-theme-input">
              <ejs-dropdownlist
                  id="theme-dropdownlist"
                  :dataSource='themeDataList'
                  :fields="themeDataFields"
                  :v-model="tabOneData.sample.theme"
                  :value="selectDropDownItemForUpdate('theme-dropdownlist', tabOneData.sample.theme, themeDataList)"
                  placeholder='Select a theme'
                  @change="tabOneData.sample.theme =
                           setDropDownItemValue('theme-dropdownlist', themeDataList)"
              ></ejs-dropdownlist>
            </b-form-group>
              <div v-if="$v.tabOneData.sample.theme.$dirty">
                <div v-if="!$v.tabOneData.sample.theme.required" class="error">Field is required</div>
              </div>
          </div>

          <!-- PROJECT -->
          <div class="form-group">
            <b-form-group id="form-project" label="Select a project:" label-for="form-theme-input">
              <ejs-dropdownlist
                  id="project-dropdownlist"
                  :dataSource='projectDataList'
                  :fields="projectDataFields"
                  :v-model="tabOneData.sample.project"
                  :value="selectDropDownItemForUpdate('project-dropdownlist', tabOneData.sample.project, projectDataList)"
                  placeholder='Select a project'
                  @change="setProjectHead(originalProjectDataList, projectDataList)"
              ></ejs-dropdownlist>
            </b-form-group>
              <div v-if="$v.tabOneData.sample.project.$dirty">
                <div v-if="!$v.tabOneData.sample.project.required" class="error">Field is required</div>
              </div>
          </div>

          <!--PROJECT HEAD-->
          <div class="form-group">
            <label for="projectHead"> Project Head(P.I)</label>
            <input id="projectHead" v-model="tabOneData.sample.projectHead" class="form-control" disabled
                   type="text"/>
          </div>

          <!--SAMPLE OWNER-->
          <div class="form-group" hidden>
            <label for="sampleOwner"> Sample Owner</label>
            <input id="sampleOwner" v-model="tabOneData.sample.sampleOwner" class="form-control" disabled
                   type="text"/>
          </div>

          <!--SAMPLE TYPE-->
          <div class="form-group">
            <b-form-group id="form-sampleType" label="Select sample type:" label-for="form-sampleType-input">
              <ejs-dropdownlist
                  id="sampleType-dropdownlist"
                  :dataSource='sampleTypeDataList'
                  :fields="sampleTypeDataFields"
                  :v-model="tabOneData.sample.sampleType"
                  :value="selectDropDownItemForUpdate('sampleType-dropdownlist',
                  tabOneData.sample.sampleType, sampleTypeDataList)"
                  placeholder='Select sample type'
                  @change="tabOneData.sample.sampleType =
                           setDropDownItemValue('sampleType-dropdownlist', sampleTypeDataList)"
              ></ejs-dropdownlist>
            </b-form-group>
              <div v-if="$v.tabOneData.sample.sampleType.$dirty">
                <div v-if="!$v.tabOneData.sample.sampleType.required" class="error">Field is required</div>
              </div>
          </div>

          <!--SPECIES-->
          <div class="form-group">
            <label for="species"> Species</label>
            <input id="species" v-model="tabOneData.sample.species" class="form-control" required type="text"/>
            <div v-if="$v.tabOneData.sample.species.$dirty">
              <div v-if="!$v.tabOneData.sample.species.required" class="error">Field is required</div>
            </div>
          </div>

          <!--DESC-->
          <div class="form-group">
            <label for="description"> Description</label>
            <textarea id="description" v-model="tabOneData.sample.description" class="form-control" name="description"
                      type="text"/>
            <div v-if="$v.tabOneData.sample.description.$dirty">
              <div v-if="!$v.tabOneData.sample.description.required" class="error">Field is required</div>
            </div>
          </div>
        </tab-content>

        <!-- TAB 2 -->
        <tab-content :before-change="handleSubmit" title="Sample Location in Institution">
          <!-- LOCATION -->
          <div class="row">
            <!-- SAMPLE COLLECTION LOCATION -->
            <div class="col">
              <div class="form-group">
                <b-form-group id="form-locationCollected" label="Select Location:" label-for="form-loc-input">
                  <ejs-dropdownlist
                      id="location-dropdownlist"
                      :dataSource='locDataList'
                      :fields="locDataFields"
                      :v-model="tabTwoData.sample.locationCollected"
                      :value="selectDropDownItemForUpdate('location-dropdownlist', tabTwoData.sample.locationCollected, locDataList)"
                      placeholder='Select location sample(s) was collected from'
                      @change="tabTwoData.sample.locationCollected =
                                setDropDownItemValue('location-dropdownlist', locDataList)"
                  ></ejs-dropdownlist>
                </b-form-group>
              </div>
              <div v-if="$v.tabTwoData.sample.locationCollected.$dirty">
                <div v-if="!$v.tabTwoData.sample.locationCollected.required" class="error">Field is required</div>
              </div>
            </div>

            <!-- SAMPLE COLLECTION DATE -->
            <div class="col">
              <div class="form-group">
                <label for="date_of_collection">Date of Collection:</label>
                <date-picker id="date_of_collection"></date-picker>
              </div>
              <div v-if="$v.tabTwoData.sample.date_of_collection.$dirty">
                <div v-if="!$v.tabTwoData.sample.date_of_collection.required" class="error">Field is required</div>
              </div>
            </div>
          </div>

          <!-- CASCADING DROPDOWNS TO DETERMINE A PLACE FOR THE SAMPLE -->
          <div>
            <sample-location-finder></sample-location-finder>
            <div v-if="$v.tabTwoData.sample.slots.$dirty">
              <div v-if="!$v.tabTwoData.sample.slots.required" class="error">
                Field is required! Select a box and fill in the samples.
              </div>
            </div>
          </div>

          <!-- Start row -->
          <div class="row">

            <!-- TEMPERATURE -->
            <div class="col">
              <div class="form-group">
                <label for="temperature">Temperature (Default in Celsius)</label>
                <input id="temperature" v-model="tabTwoData.sample.temperature" class="form-control" required
                       type="number"/>
                <div v-if="$v.tabTwoData.sample.temperature.$dirty">
                  <div v-if="!$v.tabTwoData.sample.temperature.required" class="error">Field is required</div>
                </div>
              </div>
            </div>

            <!-- AMOUNT -->
            <div class="col">
              <div class="form-group">
                <label for="amount">Amount</label>
                <input id="amount" v-model="tabTwoData.sample.amount" class="form-control" min="1" required
                       type="number"/>
                <div v-if="$v.tabTwoData.sample.amount.$dirty">
                  <div v-if="!$v.tabTwoData.sample.amount.required" class="error">Field is required</div>
                </div>
              </div>
            </div>

            <!-- QUANTITY TYPE -->
            <div class="col">
              <div class="form-group">
                <b-form-group id="form-QT" label="Select a Quantity Type:"
                              label-for="form-user-input">
                  <ejs-dropdownlist
                      id="QT-dropdownlist"
                      :dataSource='QTDataList'
                      :fields="QTDataFields"
                      :v-model="tabTwoData.sample.quantity_type"
                      :value="selectDropDownItemForUpdate('QT-dropdownlist', tabTwoData.sample.quantity_type, QTDataList)"
                      placeholder='Select a quantity type(e.g. ML, L, G ...)'
                      @change="tabTwoData.sample.quantity_type =
                               setDropDownItemValue('QT-dropdownlist', QTDataList)"
                  ></ejs-dropdownlist>
                </b-form-group>
              </div>
              <div v-if="$v.tabTwoData.sample.quantity_type.$dirty">
                <div v-if="!$v.tabTwoData.sample.quantity_type.required" class="error">Field is required</div>
              </div>
            </div>
          </div>
          <!-- End Row -->
        </tab-content>

        <!-- TAB 3 -->
        <tab-content :before-change="handleSubmit" title="Finishing Up">

          <!-- BIOHAZARD LEVEL -->
          <div class="form-group">
            <b-form-group id="form-bioHazardLevel" label="BioHazard Level Needed:"
                          label-for="form-bioHazardLevel-input">
              <ejs-dropdownlist
                  id="bioHazardLevel-dropdownlist"
                  :dataSource='bioHazardLevelDataList'
                  :fields="bioHazardLevelDataFields"
                  :v-model="tabThreeData.sample.bioHazardLevel"
                  :value="selectDropDownItemForUpdate('bioHazardLevel-dropdownlist', tabThreeData.sample.bioHazardLevel, bioHazardLevelDataList)"
                  placeholder='Select BioHazard Level Needed'
                  @change="tabThreeData.sample.bioHazardLevel =
                           setDropDownItemValue('bioHazardLevel-dropdownlist', bioHazardLevelDataList)"
              ></ejs-dropdownlist>
            </b-form-group>
            <div v-if="$v.tabThreeData.sample.bioHazardLevel.$dirty">
                <div v-if="!$v.tabThreeData.sample.bioHazardLevel.required" class="error">Field is required</div>
            </div>
          </div>

          <!-- ANALYSIS -->
          <div class="form-group">
            <label for="analysis"> Analysis</label>
            <input id="analysis" v-model="tabThreeData.sample.analysis" class="form-control" required type="text"/>
            <div v-if="$v.tabThreeData.sample.analysis.$dirty">
                <div v-if="!$v.tabThreeData.sample.analysis.required" class="error">Field is required</div>
            </div>
          </div>

          <!-- RETENTION PERIOD -->
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="retention"> Retention</label>
                <input id="retention" v-model="tabThreeData.sample.retention" class="form-control" min="1" required
                       type="number"/>
              </div>
              <div v-if="$v.tabThreeData.sample.retention.$dirty">
                <div v-if="!$v.tabThreeData.sample.retention.required" class="error">Field is required</div>
            </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="period">Select Retention Length:</label>
                <select id="period" class="custom-select" required @change="setRetentionPeriod">
                  <option selected>Select period(Days, Weeks ...)</option>
                  <option value="1">Days</option>
                  <option value="2">Weeks</option>
                  <option value="3">Months</option>
                  <option value="4">Years</option>
                </select>
              </div>
            </div>
          </div>
        </tab-content>

        <!-- FORM FOOTER -->
        <template slot="footer" scope="props">
          <div class=wizard-footer-left>
            <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle"
                           @click.native="props.prevTab()">Previous
            </wizard-button>
          </div>

          <div class="wizard-footer-right">
            <wizard-button :style="props.fillButtonStyle" style="margin-right: 150px"
              @click.native="saveFormAsDraft"
            >Save As Draft</wizard-button>

            <wizard-button v-if="!props.isLastStep" :style="props.fillButtonStyle"
                           class="wizard-footer-right" @click.native="props.nextTab()">Next
            </wizard-button>

            <wizard-button v-else :style="props.fillButtonStyle"
                           class="wizard-footer-right finish-button"
                           @click.native="handleSubmit">{{ props.isLastStep ? 'Done' : 'Next' }}
            </wizard-button>
          </div>
        </template>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueFormWizard, {TabContent} from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import axios from 'axios';
import {
  getProjectDataList, getThemeDataList, getLocationCollected, getQuantityTypeDataList, getBioHazardLevelDataList,
  handleError, pageStartLoader, redirectAfterCountDown, secureStoreGetAuthString, selectDropDownItemForUpdate,
  showFlashMessage, setProjectHead, setDropDownItemValue, secureStoreSetSampleInfo, getStoredSampleDetails,
  secureStoreDeleteSampleInfo, getSampleTypeDataList, getSampleLocationDetails, deleteSampleLocationDetails,
  deleteSampleStorageLocationDetails,
} from "@/utils/util_functions";
import { sample_resource} from "@/utils/api_paths";
import TopNav from "@/components/TopNav";
import SampleLocationFinder from "@/components/SampleLocationFinder";
import EventBus from "@/components/EventBus";
import DatePicker from "@/components/DatePicker";
import {required} from "vuelidate/lib/validators";
import $ from "jquery";

Vue.use(VueFormWizard)
Vue.use(TabContent)

export default {
  name: "jumbotron",

  data() {
    return {
      response: [],
      tabOneData: {
        sample: {
          theme: null, species: null, project: null, sampleOwner: null,
          sampleType: null, description: null, projectHead: null
        }
       },

      tabTwoData: {
        sample: {
          locationCollected: null, date_of_collection: null, slots: null,
          temperature: null, amount: null, quantity_type: null,
        }
      },

      tabThreeData: {
        sample: {
          bioHazardLevel: null, analysis: null, retention: null, convertedRetentionPeriod: null
        }
      },

      savedForm: {},
      showAlert: false,
      showOverwriteWarning: false,

      tabNum: 0, tabOne: 0, tabTwo: 1, tabThree: 2,

      // project lists and fields
      projectDataList: [], projectDataFields: {}, originalProjectDataList: [],

      // theme lists and fields
      themeDataList: [], themeDataFields: {},

      // sampleType lists and fields
      sampleTypeDataList: [], sampleTypeDataFields: {},

      // loc lists and fields
      locDataList: [], locDataFields: {},

      // QT lists and fields
      QTDataList: [], QTDataFields: {},

      // bio-hazard-level lists and fields
      bioHazardLevelDataList: [], bioHazardLevelDataFields: {},

      page_title: "Add Sample",
    };
  },

  validations: {
    tabOneData: {
      sample: {
        theme: {required}, species: {required}, project: {required},
        sampleType: {required}, description: {required},
      }
    },

    tabTwoData: {
      sample: {
        locationCollected: {required}, date_of_collection: {required}, slots: {required},
        temperature: {required}, amount: {required}, quantity_type: {required},
      }
    },

    tabThreeData: {
      sample: {
        bioHazardLevel: {required}, analysis: {required}, retention: {required}
      }
    }
  },

  mounted() {
    /** Tab 1 Events */
    // get theme data list
    EventBus.$on('get-theme-data-list', payload => {
      this.themeDataList = payload['selectorList']['items']
      this.themeDataFields = payload['selectorList']['fields']
    })

    EventBus.$on('get-sampleType-data-list', payload => {
      this.sampleTypeDataList = payload['items']
      this.sampleTypeDataFields = payload['fields']
    })

    // get and set events of project data from drop-down
    EventBus.$on('get-project-data-list', payload => {
      this.originalProjectDataList = payload['projectList']
      this.projectDataList = payload['selectorList']['items']
      this.projectDataFields = payload['selectorList']['fields']
    })

    EventBus.$on('set-project-head-details', payload => {
      this.tabOneData.sample.project = payload['project']
      this.tabOneData.sample.projectHead = payload['name']
      this.tabOneData.sample.sampleOwner = payload['email']
    })

    /** Tab 2 Events*/
    // get location/study-block data list
    EventBus.$on('get-location-data-list', payload => {
      this.locDataList = payload['items']
      this.locDataFields = payload['fields']
    })

    // get date of collection event from parent component
    EventBus.$on('date-set', payload => {
      this.tabTwoData.sample.date_of_collection = payload
    })

    EventBus.$on('new-samples', payload => {
      this.tabTwoData.sample.slots = payload
    })

    // get QT data list
    EventBus.$on('get-QT-data-list', payload => {
      this.QTDataList = payload['items']
      this.QTDataFields = payload['fields']
    })

    /**Tab 3 Events*/
    // get bio-hazard data list
    EventBus.$on('get-bio-hazard-level-data-list', payload => {
      this.bioHazardLevelDataList = payload['items']
      this.bioHazardLevelDataFields = payload['fields']
    })
  },

  methods: {
    // util functions
    selectDropDownItemForUpdate, setDropDownItemValue, setProjectHead, secureStoreDeleteSampleInfo,

    onCreated(){
      this.savedForm = getStoredSampleDetails();

      /* check for at least one known property in the sample object, if it exists and it is not null,
      fetch the saved sample, otherwise create a new sample.
      The property theme has been used for this case since it is required and found in the first tab. */
      if ('theme' in this.savedForm && this.savedForm['theme'] !== null){ this.showAlert = true }
    },

    restoreSavedForm(){
      // fill in the current form with data from saved form
      //tabOne
      this.tabOneData.sample.theme = this.savedForm['theme']
      this.tabOneData.sample.project = this.savedForm['project']
      this.tabOneData.sample.projectHead = this.savedForm['projectHead']
      this.tabOneData.sample.sampleOwner = this.savedForm['sampleOwner']
      this.tabOneData.sample.sampleType = this.savedForm['sampleType']
      this.tabOneData.sample.species = this.savedForm['species']
      this.tabOneData.sample.description = this.savedForm['description']

      //tabTwo
      this.tabTwoData.sample.locationCollected = this.savedForm['locationCollected']
      this.tabTwoData.sample.date_of_collection = this.savedForm['date_of_collection']
      // emit event to be listened in sample-location finder component.
      EventBus.$emit('retrieve_sample_location_details', this.savedForm.sampleLocation)
      this.tabTwoData.sample.slots = this.savedForm['slots']
      this.tabTwoData.sample.temperature = this.savedForm['temperature']
      this.tabTwoData.sample.amount = this.savedForm['amount']
      this.tabTwoData.sample.quantity_type = this.savedForm['quantity_type']

      //tabThree
      this.tabThreeData.sample.bioHazardLevel = this.savedForm['bioHazardLevel']
      this.tabThreeData.sample.analysis = this.savedForm['analysis']
      this.tabThreeData.sample.retention = this.savedForm['retention']
      this.tabThreeData.sample.convertedRetentionPeriod = this.savedForm['convertedRetentionPeriod']

      // clear alert
      $(".alert").remove()
      this.showAlert = false
    },

    // if user does not wish to restore the form delete all the states of the form that are saved
    deleteSavedForm(){
      secureStoreDeleteSampleInfo(); this.showOverwriteWarning=false;
      deleteSampleLocationDetails(); deleteSampleStorageLocationDetails()
    },

    setRetentionPeriod() {
      let periodSelect = document.getElementById("period")
      let periodValue = parseInt(periodSelect.options[periodSelect.selectedIndex].value);

      if (periodValue === 1) {
        this.tabThreeData.sample.convertedRetentionPeriod = this.tabThreeData.sample.retention * 1
      } else if (periodValue === 2) {
        // convert week to days
        this.tabThreeData.sample.convertedRetentionPeriod = this.tabThreeData.sample.retention * 7
      } else if (periodValue === 3) {
        // convert months to days
        this.tabThreeData.sample.convertedRetentionPeriod = this.tabThreeData.sample.retention * 30
      } else if (periodValue === 4) {
        //  convert years to days
        this.tabThreeData.sample.convertedRetentionPeriod = this.tabThreeData.sample.retention * 365
      }
    },

    handleSubmit() {
      this.$v.$touch();
      if (this.tabNum === 0) {
        if (this.$v.tabOneData.$invalid){
          return; // stop here if form is invalid
        }
        // emit event to trigger the fetching of lab data required in the next page
        EventBus.$emit('locationFinder')
        this.tabNum++
        return true;
      } else if (this.tabNum === 1) {
        if (this.$v.tabTwoData.$invalid){
          return; // stop here if form is invalid
        }

        this.tabNum++
        return true;
      } else if (this.tabNum === 2) {
        if (this.$v.tabThreeData.$invalid){
          return; // stop here if form is invalid
        }

        this.tabNum = 0
        return this.formSubmit()
      }
    },

    formSubmit() {
      let loader = pageStartLoader(this, 'dots')

      axios.post(sample_resource, {
        // tabOneData
        theme: this.tabOneData.sample.theme,
        project: this.tabOneData.sample.project,
        user: this.tabOneData.sample.sampleOwner,
        project_owner: this.tabOneData.sample.projectHead,
        sample_type: this.tabOneData.sample.sampleType,
        animal_species: this.tabOneData.sample.species,
        sample_description: this.tabOneData.sample.description,

        // tabTwoData
        location_collected: this.tabTwoData.sample.locationCollected,
        date_of_collection: this.tabTwoData.sample.date_of_collection,
        slots: JSON.stringify(this.tabTwoData.sample.slots),
        temperature: this.tabTwoData.sample.temperature,
        amount: this.tabTwoData.sample.amount,
        quantity_type: this.tabTwoData.sample.quantity_type,

        // tabThreeData
        bio_hazard_level: this.tabThreeData.sample.bioHazardLevel,
        analysis: this.tabThreeData.sample.analysis,
        retention_period: this.tabThreeData.sample.convertedRetentionPeriod,
      }, {
        headers:
            {
              Authorization: secureStoreGetAuthString()
            }
      })
          .then((response) => {
            let is_creating = false
            EventBus.$emit('samples-created', is_creating)
            setTimeout(() => {
              loader.hide();
              showFlashMessage(this, 'success', response.data['message'], '');
              secureStoreDeleteSampleInfo();
              redirectAfterCountDown(this, '/sample')
            }, 4000)
          })
          .catch((error) => {
            handleError(this, error, loader)
          });
    },

    //  SAVE FORM AS DRAFT FUNCTIONALITY
    saveFormAsDraft(){
      let sample_location_details = getSampleLocationDetails()
      secureStoreSetSampleInfo(this.tabOneData, this.tabTwoData, this.tabThreeData, sample_location_details)
      showFlashMessage(this, 'success', 'Success', 'Form saved!')
    }
  },

  created() {
    getBioHazardLevelDataList(); getLocationCollected(); getSampleTypeDataList();
    getProjectDataList(); getQuantityTypeDataList(); getThemeDataList();
    this.onCreated()
  },

  components: {DatePicker, SampleLocationFinder, TopNav}
};
</script>
